import { render, staticRenderFns } from "./TkSelectYesOrNo.vue?vue&type=template&id=56e75bd1&"
import script from "./TkSelectYesOrNo.vue?vue&type=script&lang=js&"
export * from "./TkSelectYesOrNo.vue?vue&type=script&lang=js&"
import style0 from "./TkSelectYesOrNo.vue?vue&type=style&index=0&id=56e75bd1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports